import listings from './listings';
import listingBulks from './listingBulks';
import promotions from './promotions';
import subscriptions from './subscriptions';
import newsletter from './newsletter';

export default {
  listings,
  listingBulks,
  promotions,
  subscriptions,
  newsletter,
};
